export default "__VITE_ASSET__04b58f50__"